module.exports = __webpack_public_path__ + "c76d0588b84c718c1ab92c604aa8372f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/logo_gia.png
// module id = 859
// module chunks = 0